import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { OverlayTrigger, Popover } from "react-bootstrap";
import i18n from "./DropdownLanguage/i18n";

class ServiceProviderCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }
  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
        </Popover.Content>
      </Popover>
    );
  }


  render() {
    const { arraylist, currentPage, pageSize, totalRecords, t } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {arraylist && arraylist.length != 0 ? (
          <Paginator
            first={currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !--{t("CommonText.NoItem")}--!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, eyeclick, deleteServiceProvider, t } = this.props;
    const isArabic = i18n.language === 'arab'
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div className="card mb-2" style={{ overflow: "hidden", position: "relative" }}>
            <div className="p-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-11 col-10 m-auto">
                    <div className="row px-4">
                      <div className="col-sm-3">
                        <span><strong>{t("ShipDetailsScreen.ServiceProvider")} : </strong><span className="italicFont ">{item.serviceProviderName} </span></span>
                      </div>
                      <div className="col-sm-3">
                        <span><strong>{t("ServicedByScreenContent.Email")} : </strong><span className="italicFont ">{item.email} </span></span>
                      </div>
                      <div className="col-sm-3">
                        <span className={`${isArabic ? 'arabic' : ''}`}><strong>{t("ServicedByScreenContent.Phone1")}  </strong><strong>:</strong><span className="italicFont ">{item.phone1} </span></span>
                      </div>
                      <div className="col-sm-3">
                        <span className={`${isArabic ? 'arabic' : ''}`}><strong>{t("ServicedByScreenContent.Phone2")}  </strong><strong>:</strong><span className="italicFont ">{item.phone2} </span></span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1 col-sm-2 col-2 m-auto text-right">
                    <div className="text-center">
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderedit()}
                      >
                        <i className="fa fa-edit fa-lg click px-1" onClick={() => eyeclick(item)} aria-hidden="true" style={{ color: ' #1a3464', fontSize: "1.8rem" }}></i>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderdelete()}
                      >
                        <i className="fa fa-trash click px-1" onClick={() => deleteServiceProvider(item)} aria-hidden="true" style={{ color: ' #1a3464', fontSize: "1.8rem" }}></i>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ServiceProviderCard)));
